import { render } from "./ow-expense-types.vue?vue&type=template&id=36929700"
import script from "./ow-expense-types.vue?vue&type=script&lang=js"
export * from "./ow-expense-types.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__